export enum StarBucksFeatureFlags {
    EnableConfigureHolidayChargeCalculation = 'enable-configure-holiday-charge-calculation',
    BillableOrientationConfigAllowSpecificType = 'facility-billable-orientation-allow-specific-type',
    FixTimecardHistoryCommentImport = 'fix-timecard-history-comment-during-imports',
    TimecardImportErrorsGroupShiftsByDay = 'timecard-import-errors-group-shifts-by-day',
    TimecardSyncV2 = 'timecard-sync-v2'
}
